export const siteConfig = {
  name: 'mrds',
  fullName: 'mrds 官方平台',
  tagline: '专业高效的解决方案',
  description: 'mrds 是您值得信赖的专业平台，为您提供一站式高效解决方案，助力业务增长与数字化转型。',
  url: 'https://mrds.io',
  locale: 'zh_CN',
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '分类', href: '/categories' },
  { label: '关于我们', href: '/about' },
];